import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconCamera = ({ id, color, width = 50, style, ...restProps }: IProps) => {
  const viewBoxWidth = 50;
  const viewBoxHeight = 42;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M7.49 7.255l-.756.529c-2.201 1.541-3.199 3.096-3.199 4.711v21.57c0 2.414 1.99 4.393 4.428 4.393h34.074c2.439 0 4.428-1.979 4.428-4.392v-21.57c0-2.414-1.99-4.393-4.428-4.393H23.61V5.045c-.45-.804-1.545-1.503-2.419-1.503H9.676c-.81 0-1.746.644-2.187 1.491v2.222zm34.547-2.694C46.423 4.561 50 8.12 50 12.495v21.57C50 38.442 46.423 42 42.037 42H7.963C3.577 42 0 38.441 0 34.066v-21.57C0 9.832 1.37 7.468 3.954 5.44V4.334l.116-.305C4.945 1.732 7.264 0 9.676 0H21.19c2.429 0 4.973 1.754 5.839 4.029l.116.305v.227h14.891zM25 34.965c-6.468 0-11.733-5.238-11.733-11.684 0-6.447 5.265-11.685 11.733-11.685 6.468 0 11.733 5.238 11.733 11.685 0 6.446-5.265 11.684-11.733 11.684zm0-3.542c4.52 0 8.198-3.658 8.198-8.142 0-4.485-3.677-8.143-8.198-8.143-4.52 0-8.198 3.658-8.198 8.143 0 4.484 3.677 8.142 8.198 8.142zm2.273-13.08c0 .783-.608 1.392-1.39 1.392-2.3 0-4.166 1.87-4.166 4.175 0 .782-.607 1.391-1.389 1.391a1.372 1.372 0 0 1-1.389-1.391c0-3.827 3.125-6.958 6.945-6.958.781 0 1.389.609 1.389 1.391z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconCamera;
